import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const choice = localStorage.getItem('cookieConsent');
      if (!choice) setVisible(true);
    } catch (e) {
      // If localStorage is not available, show the banner
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try { localStorage.setItem('cookieConsent', 'accepted'); } catch {}
    setVisible(false);
    try { window.dispatchEvent(new Event('cookie-consent-accepted')); } catch {}
  };

  const decline = () => {
    try { localStorage.setItem('cookieConsent', 'declined'); } catch {}
    setVisible(false);
    try { window.dispatchEvent(new Event('cookie-consent-declined')); } catch {}
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50">
      <div className="mx-auto max-w-5xl p-4 m-4 rounded-lg border border-sage-200 shadow-lg bg-white">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <p className="text-sm text-charcoal-700">
            We use cookies to enhance your experience and improve our services. Read our{' '}
            <Link to="/terms-conditions#cookies" className="text-sage-700 hover:text-sage-800 underline">
              Cookie Policy
            </Link>
            . You can accept or decline non-essential cookies.
          </p>
          <div className="flex items-center gap-2 justify-end">
            <button
              type="button"
              onClick={decline}
              className="px-4 py-2 rounded-md border border-charcoal-200 text-charcoal-800 hover:bg-charcoal-50 transition-colors"
            >
              Decline
            </button>
            <button
              type="button"
              onClick={accept}
              className="px-4 py-2 rounded-md bg-sage-600 text-white hover:bg-sage-700 transition-colors"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
